import React from 'react';

const ModelHomeView = () => {
    return (
        <h4>Models Home View</h4>
    );
}

export default ModelHomeView;